import axiosClient from "./axiosClient";
const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";

export function registerUser(userDetails) {
  return axiosClient
    .post("/licensing/validate_license/", userDetails)
    .then((res) => res.data);
}

export function loginUser(credentials) {
  return axiosClient
    .post("/licensing/login_user/", credentials)
    .then((res) => res.data);
}

export function resetPassword(resetDetails) {
  return axiosClient
    .post("/licensing/reset_password/", resetDetails)
    .then((res) => res.data);
}
export function loginAdmin(admin_credentials) {
  return axiosClient
    .post("/licensing/login_admin/", admin_credentials)
    .then((res) => res.data);
}

export function verifyMfaCode(mfaDetails) {
  const url = `${BASE_URL}/licensing/api/verify-mfa/`;

  return fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(mfaDetails),
  })
    .then((response) => {
      if (!response.ok) {
        return response.json().then((errorData) => {
          throw new Error(errorData.status || "MFA verification failed");
        });
      }
      return response.json();
    })
    .catch((error) => {
      console.error("MFA verification error:", error);
      throw error;
    });
}

export function verifyAdminMfaCode(mfaDetails) {
  const url = `${BASE_URL}/licensing/api/verify-admin-mfa/`;

  return fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(mfaDetails),
  })
    .then((response) => {
      if (!response.ok) {
        return response.json().then((errorData) => {
          throw new Error(errorData.status || "MFA verification failed");
        });
      }
      return response.json();
    })
    .catch((error) => {
      console.error("MFA verification error:", error);
      throw error;
    });
}
